import { render, staticRenderFns } from "./acciones-promocion-prevencion.vue?vue&type=template&id=0e4944ed&scoped=true&"
import script from "./acciones-promocion-prevencion.vue?vue&type=script&lang=js&"
export * from "./acciones-promocion-prevencion.vue?vue&type=script&lang=js&"
import style0 from "./acciones-promocion-prevencion.vue?vue&type=style&index=0&id=0e4944ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4944ed",
  null
  
)

export default component.exports